<template>

  <div :id="editorName"  v-bind:style="{  height: editorHeight + 'px' }"></div>


</template>
<script>
//const beautify = window.ace.require("ace/ext/beautify");
export default {
  name: "AceEditor",
  props: ["editorId", "content", "lang", "theme", "width", "height"],
  data: function() {
    return {
      editor: Object,
      beforeContent: "",
      editorName:`ace${this.editorId}`,
      editorWidth: this.width || 500,
      editorHeight: this.height || 400,
    };
  },
  methods: {},
  mounted: function() {
    const lang = this.lang || "json";
    const theme = this.theme || "tomorrow_night_eighties";

    this.editor = window.ace.edit(this.editorName);
    if( this.content && lang ==='json'){
        const text = JSON.stringify(this.content, null, 2);
        this.editor.setValue(text, 1);
    }
    else{
      this.editor.setValue(this.content,1);
    }

    this.editor.getSession().setMode(`ace/mode/${lang}`);
    this.editor.setTheme(`ace/theme/${theme}`);
   // beautify.beautify(this.editor.getSession());
    this.editor.on("change", () => {
      this.beforeContent = this.editor.getValue();
      this.$emit("change-content", this.editor.getValue());
    });
  },
  watch: {
    content(value) {
       const text = JSON.stringify(this.content, null, 2);
      if (this.beforeContent !== text) {
        this.editor.setValue(text, 1);
      }
    }
  }
};
</script>
<style scoped>
</style>
